export const MODULE_NAME = 'externalScripts';
